import api from '@pray/shared/utils/api';

/**
 * Get lead campaign statistics
 * Returns total campaigns, active campaigns, total leads, and fulfilled count.
 * leadsFrom/leadsTo (ISO 8601, inclusive) narrow the lead totals; the campaign counts ignore them.
 */
export const getLeadCampaignStats = async ({ artistId = '', leadsFrom = '', leadsTo = '' } = {}) => {
  const url = `/web/studio/lead-campaigns/stats`;
  const params = {};
  if (artistId) params.artist_id = artistId;
  if (leadsFrom) params.leads_from = leadsFrom;
  if (leadsTo) params.leads_to = leadsTo;
  const response = await api.executeGetRequest(url, params);
  return response.data;
};
